module.exports = __webpack_public_path__ + "img/manutencao.6d8b1b5b.png";